
      var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgBankpayment = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.023 12h-3.86C3.522 12 3 12.521 3 13.164v14.672C3 28.48 3.521 29 4.164 29h23.672C28.48 29 29 28.479 29 27.836V13.164C29 12.52 28.479 12 27.836 12h-3.859",
  stroke: "#000",
  strokeWidth: 2
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.023 12.364h-3.86c-.642 0-1.163.52-1.163 1.163v1.31C3 15.478 3.52 16 4.163 16H29v-2.473c0-.642-.521-1.163-1.164-1.163h-3.859",
  stroke: "#000",
  strokeWidth: 2
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M16 3a9 9 0 0 1 8.486 12h-2.16a7 7 0 1 0-12.65 0H7.513A9 9 0 0 1 16 3Z",
  fill: "var(--theme-primary, #810ea9)"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M16.304 13.96c3.6 0 4.365-1.818 4.505-4.606l.042-.683a.533.533 0 0 0-.532-.566h-.878c-.29 0-.526.231-.534.52l-.012.495c-.09 2.275-.255 3.346-2.361 3.346-.08 0-.267-.016-.447-.034a.526.526 0 0 1-.473-.478l-.083-.92a.533.533 0 0 0-.53-.486h-.596a.533.533 0 0 0-.53.586l.227 2.283a.531.531 0 0 0 .5.478c.514.027 1.325.065 1.702.065Z",
  fill: "var(--theme-primary, #810ea9)",
  stroke: "var(--theme-light, #f9f3fb)",
  strokeWidth: 0.107
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M11.327 13.338c0 .294.238.533.533.533h.745a.533.533 0 0 0 .534-.534v-3.126c0-.294.239-.533.533-.533h1.879c.447 0 .664.156.664.557v.727c0 .295.238.534.533.534h.682a.533.533 0 0 0 .533-.534v-.727c0-1.672-.69-2.13-2.412-2.13H11.86a.533.533 0 0 0-.533.534v4.699Z",
  fill: "var(--theme-primary, #810ea9)",
  stroke: "var(--theme-light, #f9f3fb)",
  strokeWidth: 0.107
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\" fill=\"none\">\r\n  <path d=\"M8.02273 12H4.16364C3.52098 12 3 12.521 3 13.1636V27.8364C3 28.479 3.52098 29 4.16364 29H27.8364C28.479 29 29 28.479 29 27.8364V13.1636C29 12.521 28.479 12 27.8364 12H23.9773\" stroke=\"#000000\" stroke-width=\"2\"/>\r\n  <path d=\"M8.02253 12.3638H4.16339C3.52073 12.3638 2.99976 12.8847 2.99976 13.5274V14.8365C2.99976 15.4792 3.52074 16.0001 4.16339 16.0001H29V13.5274C29 12.8847 28.479 12.3638 27.8364 12.3638H23.9772\" stroke=\"#000000\" stroke-width=\"2\"/>\r\n  <path d=\"M16 2.99982C20.9706 2.99982 25 7.02925 25 11.9998C25 13.0519 24.8181 14.0613 24.4863 14.9998H22.3252C22.7573 14.0904 23 13.0736 23 11.9998C23 8.13382 19.866 4.99982 16 4.99982C12.134 4.99982 9 8.13382 9 11.9998C9 13.0736 9.24273 14.0904 9.6748 14.9998H7.51367C7.18191 14.0613 7 13.0519 7 11.9998C7 7.02925 11.0294 2.99982 16 2.99982Z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n  <path d=\"M16.3043 13.96C19.9032 13.96 20.6689 12.1423 20.8093 9.35444L20.8511 8.67144C20.87 8.36463 20.6262 8.10547 20.3188 8.10547H19.4406C19.1512 8.10547 18.9147 8.33616 18.9074 8.62539L18.895 9.12026C18.8056 11.3952 18.6397 12.4657 16.534 12.4657C16.4536 12.4657 16.2674 12.4499 16.0868 12.4325C15.8344 12.4083 15.637 12.2062 15.6143 11.9536L15.5313 11.0331C15.5065 10.7582 15.2761 10.5477 15.0001 10.5477H14.4049C14.0894 10.5477 13.8429 10.82 13.8742 11.134L14.1022 13.417C14.1283 13.6783 14.3407 13.8817 14.6029 13.8952C15.116 13.9216 15.9273 13.96 16.3043 13.96Z\" fill=\"var(--theme-primary, #810ea9)\" stroke=\"var(--theme-light, #f9f3fb)\" stroke-width=\"0.106667\"/>\r\n  <path d=\"M11.3267 13.3375C11.3267 13.632 11.5654 13.8708 11.86 13.8708H12.6055C12.9001 13.8708 13.1389 13.632 13.1389 13.3375V10.2112C13.1389 9.91661 13.3777 9.67783 13.6722 9.67783H15.5509C15.9976 9.67783 16.2145 9.83395 16.2145 10.2354V10.9622C16.2145 11.2567 16.4533 11.4955 16.7479 11.4955H17.4296C17.7241 11.4955 17.9629 11.2567 17.9629 10.9622V10.2354C17.9629 8.56268 17.2738 8.10547 15.5509 8.10547H11.86C11.5654 8.10547 11.3267 8.34425 11.3267 8.6388V13.3375Z\" fill=\"var(--theme-primary, #810ea9)\" stroke=\"var(--theme-light, #f9f3fb)\" stroke-width=\"0.106667\"/>\r\n\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/bankpayment.b6f44bfd7960df081f0ac71d948fecd4.svg"),
        {
          React: SvgBankpayment,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      